import { AnalyticsBrowser, type SegmentEvent } from '@segment/analytics-next';
import { stringAsBoolean } from 'helpers/generic';

const { REACT_APP_SEGMENT_DATA_KEY, REACT_APP_USE_SEGMENT_TRACKING } = process.env;

const IS_SEGMENT_TRACKING_ENABLED = stringAsBoolean(REACT_APP_USE_SEGMENT_TRACKING!);

function initializeSegment() {
	if (!shouldInit()) return;

	try {
		const analytics = AnalyticsBrowser.load({
			writeKey: REACT_APP_SEGMENT_DATA_KEY!
		});
		registerScreenDimensions(analytics);
		return analytics;
	} catch (e) {
		console.log(e);
	}
}

function shouldInit() {
	if (!IS_SEGMENT_TRACKING_ENABLED) return;

	if (!(REACT_APP_SEGMENT_DATA_KEY && REACT_APP_SEGMENT_DATA_KEY.length > 0)) {
		return console.error('Segment integration enabled but no key found.');
	}

	return true;
}

function registerScreenDimensions(analytics: AnalyticsBrowser) {
	void analytics
		.addSourceMiddleware(({ payload, next }) => {
			addScreenDimensions(payload.obj);
			next(payload);
		})
		.catch(error => {
			console.error('Failed to register screen-dimensions middleware:', error);
		});
}

export function addScreenDimensions(event: SegmentEvent) {
	if (event.type !== 'track' && event.type !== 'page') {
		return;
	}
	event.properties = {
		...event.properties,
		'Screen Width': window.screen.width,
		'Screen Height': window.screen.height,
		'Viewport Width': window.innerWidth,
		'Viewport Height': window.innerHeight
	};
}

export const SegmentComponent = initializeSegment();
